import React from 'react';

import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'src/registry/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from 'src/registry/ui/DropdownMenu';
import { Skeleton } from 'src/registry/ui/Skeleton';
import { cn } from 'src/utils/shadcn';

type DropdownButtonGroupProps = {
    children: React.ReactNode;
    dropdownButtonTitle: string;
    isLoading?: boolean;
};

const DropdownButtonGroup = ({ children, dropdownButtonTitle, isLoading = false }: DropdownButtonGroupProps) => {
    const childArray = React.Children.toArray(children);

    if (isLoading) {
        return (
            <div className="grid w-full grid-cols-2 gap-2">
                <Skeleton className="h-10 w-full" />
                <Skeleton className="h-10 w-full" />
            </div>
        );
    }

    if (childArray.length <= 2) {
        return (
            <div className={cn('grid w-full gap-2', childArray.length === 1 ? 'grid-cols-1' : 'grid-cols-2')}>
                {childArray}
            </div>
        );
    }

    const visibleButtons = childArray.slice(0, 1);
    const dropdownButtons = childArray.slice(1);

    return (
        <div className={cn('grid w-full gap-2', childArray.length === 1 ? 'grid-cols-1' : 'grid-cols-2')}>
            {visibleButtons}
            <DropdownMenu modal={false}>
                <DropdownMenuTrigger asChild>
                    <Button variant="outline" className="cursor-pointer justify-between">
                        <div>{dropdownButtonTitle}</div>
                        <FontAwesomeIcon icon={faChevronDown} />
                    </Button>
                </DropdownMenuTrigger>

                <DropdownMenuContent align="end">
                    <DropdownMenuGroup>
                        <div className="flex flex-col gap-2 p-1">
                            {dropdownButtons.map((button, index) => (
                                <DropdownMenuItem key={index} asChild>
                                    {button}
                                </DropdownMenuItem>
                            ))}
                        </div>
                    </DropdownMenuGroup>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};

export default DropdownButtonGroup;
